import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MediaVideoModel } from '@modules/media/models/media-video.model';
import { WindowService } from '@modules/shared/services/window.service';
import { ActionIcons, ButtonItem } from '@modules/ui/action-container/action-container.component';

import { VideoWithIndex } from '../interfaces/video-with-index.interface';

@Component({
  selector: 'mb-masonry-gallery',
  templateUrl: './masonry-gallery.component.html',
  styleUrls: ['./masonry-gallery.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MasonryGalleryComponent implements OnInit {
  public displayedVideos: MediaVideoModel[] = [];
  public allVideosVisible = false;
  public showButtons = false;
  public page = 1;

  private readonly ITEMS_PER_PAGE = 6;

  @ViewChild('scrollAnchor') scrollAnchor!: ElementRef<any>;
  @ViewChildren('videoGridItem') videoGridItem!: QueryList<any>;

  @Input() items: MediaVideoModel[] = [];
  @Input() buttonItems: ButtonItem[] = [];

  @Output() itemClicked = new EventEmitter<VideoWithIndex>();
  @Output() itemActionClicked = new EventEmitter<{ action: ActionIcons; media: MediaVideoModel }>();

  constructor(private windowService: WindowService, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.displayedVideos = this.items.slice(0, this.page * this.ITEMS_PER_PAGE);
    if (this.displayedVideos.length >= this.items.length) {
      this.allVideosVisible = true;
    } else {
      this.showButtons = true;
    }
  }

  public onToggleAllClick(): void {
    if (this.displayedVideos.length < this.items.length) {
      this.incrementScroll();
      this.displayedVideos = this.items;
      this.allVideosVisible = true;
    } else {
      this.page = 1;
      this.displayedVideos = this.items.slice(0, this.page * this.ITEMS_PER_PAGE);
      this.allVideosVisible = false;
      this.resetScrollPosition();
    }
  }

  public onPagerButtonClick(): void {
    this.page++;
    this.incrementScroll();
    this.displayedVideos = this.items.slice(0, this.page * this.ITEMS_PER_PAGE);
    this.allVideosVisible = this.displayedVideos.length >= this.items.length;
    this.cdr.detectChanges();
  }

  private resetScrollPosition(): void {
    const scrollTargetRect = this.scrollAnchor.nativeElement.getBoundingClientRect();
    const calc = scrollTargetRect.top + window.pageYOffset - 200;
    this.windowService.scrollTo(calc, 0);
  }

  private incrementScroll(): void {
    const tops = this.videoGridItem.map((item) => item.nativeElement.getBoundingClientRect().top).sort();
    this.windowService.scrollTo(window.pageYOffset - tops[tops.length - 1], 0);
  }
}
